/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-20 19:40 VN — WEB-20261020-suzitee-search
   Đã làm: ô search kiểu almagems chạy bằng search có sẵn của Shopify (thay app Searchanise), không thư viện ngoài.
   - Mobile/tablet (header hiện icon, <800px): bấm kính lúp header → ô search bo tròn full-width ngay dưới header, focus sẵn, nút X đóng;
     chưa gõ = "Popular suggestions" (section sz-search-ui); gõ ≥2 ký tự = gợi ý từ khoá + danh mục + SP có ảnh/giá
     (Shopify Predictive Search, section sz-predictive-search). Chặn panel search cũ của Turbo.
   - Desktop (header hiện ô search, ≥800px): ô search header giữ nguyên chỗ; focus = dropdown Popular suggestions; gõ = dropdown gợi ý 2 cột.
   - Trang /search 0 kết quả / chưa có từ khoá: chép chip Popular suggestions vào ô [data-szs-pop].
   Hiệu năng: không MutationObserver, không timer lặp; gõ phím debounce 160ms + bỏ qua kết quả cũ + cache theo từ khoá;
   chỉ fetch khi khách gõ. Mọi handler try/catch để lỗi ở đây không chặn script khác. */
(function () {
  'use strict';
  // InstantClick (theme bật ở home/collection/cart) thay <body> khi bấm link rồi chạy lại script trong body:
  // lần chạy lại chỉ gọi refresh() (gắn lại vào DOM mới), không đăng ký listener lần 2.
  if (window.__szSearch) { try { window.__szSearch.refresh(); } catch (e) {} return; }
  window.__szSearch = { refresh: function () {} };
  var D = document, W = window;
  // Header Turbo đổi icon ↔ ô search ở 799px (sz_desktop_gh.css) — panel/dropdown chọn theo phần tử ĐANG HIỆN, mốc này chỉ để đóng khi đổi khổ + bỏ dựng sẵn trên desktop.
  var WIDE = W.matchMedia('(min-width: 799px)');
  var tpl = null, cfg = null;
  function getTpl() { if (!tpl || !D.contains(tpl)) tpl = D.getElementById('sz-search-tpl'); return tpl; }
  function getCfg() { if (!cfg || !D.contains(cfg)) cfg = D.querySelector('[data-sz-search-cfg]'); return cfg; }
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  var SEARCH = ROOT + 'search';
  var MIN = 2;
  var cache = {};
  var ICON_SEARCH = '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm5.3-2.2L21 21"/></svg>';
  var ICON_X = '<svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" d="M5 5l14 14M19 5 5 19"/></svg>';

  function attr(el, n) { return el ? el.getAttribute(n) || '' : ''; }
  function popularNode() {
    try { var t = getTpl(); return t && t.content && t.content.firstElementChild ? t.content.firstElementChild.cloneNode(true) : null; } catch (e) { return null; }
  }
  function curTerms() {
    try { return location.pathname.replace(/\/$/, '') === SEARCH.replace(/\/$/, '') ? (new URL(location.href).searchParams.get('q') || '').replace(/\*/g, '') : ''; } catch (e) { return ''; }
  }

  // ── Trang /search: chip Popular suggestions cho trạng thái 0 kết quả / chưa có từ khoá ──
  function fillPop() {
    try {
      D.querySelectorAll('[data-szs-pop]').forEach(function (slot) {
        if (slot.childElementCount) return;
        var n = popularNode(); if (!n) return;
        n.querySelectorAll('a').forEach(function (a) { slot.appendChild(a); });
      });
    } catch (e) {}
  }
  fillPop();

  // ── Bộ điều khiển dropdown dùng chung (mobile panel + desktop) ──
  function Drop(input, box) {
    this.input = input; this.box = box; this.timer = 0; this.shown = '';
  }
  Drop.prototype.update = function () {
    var self = this, v = (this.input.value || '').trim();
    clearTimeout(this.timer);
    if (v.length < MIN) { this.popular(); return; }
    if (cache[v]) { this.paint(cache[v], v); return; }
    this.box.setAttribute('aria-busy', 'true');
    this.timer = setTimeout(function () { self.fetch(v); }, 160);
  };
  Drop.prototype.popular = function () {
    if (this.shown === '#pop') return;
    var n = popularNode();
    this.box.textContent = '';
    if (n) this.box.appendChild(n);
    this.shown = '#pop';
    this.box.removeAttribute('aria-busy');
  };
  Drop.prototype.fetch = function (v) {
    var self = this;
    // KHÔNG huỷ request cũ bằng AbortController: wrapper fetch của script bên thứ 3 trên trang sinh lỗi "Unhandled AbortError" (đo 20/10).
    // Kết quả cũ về muộn bị bỏ qua (chỉ vẽ khi ô search vẫn đúng từ khoá đó); gõ phím đã debounce nên ít request thừa.
    var url = SEARCH + '/suggest?q=' + encodeURIComponent(v) +
      '&section_id=sz-predictive-search' +
      '&resources%5Btype%5D=query,product,collection&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-szp]');
        if (!el) throw new Error('no section');
        cache[v] = el;
        if ((self.input.value || '').trim() === v) self.paint(el, v);
      })
      .catch(function () { if ((self.input.value || '').trim() === v) self.box.removeAttribute('aria-busy'); });
  };
  Drop.prototype.paint = function (el, v) {
    this.box.removeAttribute('aria-busy');
    if (this.shown === 'q:' + v) return;
    var n = D.importNode(el, true);
    // Không có kết quả gợi ý → nối thêm Popular suggestions để khách vẫn có lối đi.
    if (n.querySelector('[data-szp-none]')) { var p = popularNode(); if (p) { var h = p.querySelector('.szsp-pop__h'); if (h) h.remove(); n.appendChild(p); } }
    this.box.textContent = '';
    this.box.appendChild(n);
    this.shown = 'q:' + v;
  };
  Drop.prototype.reset = function () { this.shown = ''; };

  // Phím mũi tên: input → link đầu; trong danh sách lên/xuống; Esc đóng (do caller).
  function arrowNav(e, input, box) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var links = [].slice.call(box.querySelectorAll('a'));
    if (!links.length) return;
    var i = links.indexOf(D.activeElement);
    e.preventDefault();
    if (e.key === 'ArrowDown') (links[i + 1] || links[0]).focus();
    else if (i <= 0) input.focus(); else links[i - 1].focus();
  }

  // ── MOBILE / TABLET: panel dưới header ──
  var ov = null, ovInput = null, ovDrop = null, ovBox = null, lastFocus = null;
  function headerBottom() {
    var h = D.querySelector('#header') || D.querySelector('.header') || D.querySelector('header');
    var b = 0;
    try { if (h) { var r = h.getBoundingClientRect(); b = r.bottom; } } catch (e) {}
    if (!(b > 0)) b = 0;
    return Math.min(Math.round(b), 160);
  }
  function build() {
    ov = D.createElement('div');
    ov.className = 'szsp';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Search');
    ov.hidden = true;
    ov.innerHTML =
      '<div class="szsp__scrim" data-szsp-close></div>' +
      '<div class="szsp__box">' +
        '<form class="szsp__form" action="' + SEARCH + '" method="get" role="search">' +
          '<input type="hidden" name="type" value="product"><input type="hidden" name="options[prefix]" value="last">' +
          '<span class="szsp__icon">' + ICON_SEARCH + '</span>' +
          '<input class="szsp__input" type="search" name="q" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search" aria-label="Search" aria-controls="szsp-drop" aria-autocomplete="list">' +
          '<button type="button" class="szsp__x" data-szsp-close aria-label="Close search">' + ICON_X + '</button>' +
        '</form>' +
        '<div class="szsp__drop" id="szsp-drop" aria-live="polite"></div>' +
      '</div>';
    D.body.appendChild(ov);
    ovInput = ov.querySelector('.szsp__input');
    ovInput.placeholder = attr(getCfg(), 'data-ph') || 'Search';
    ovBox = ov.querySelector('.szsp__drop');
    ovDrop = new Drop(ovInput, ovBox);
    ovInput.addEventListener('input', function () { try { ovDrop.update(); } catch (e) {} });
    ovInput.addEventListener('keydown', function (e) { try { arrowNav(e, ovInput, ovBox); } catch (err) {} });
    ovBox.addEventListener('keydown', function (e) { try { arrowNav(e, ovInput, ovBox); } catch (err) {} });
    // Tab không thoát ra trang phía sau khi panel đang che (dialog aria-modal).
    ov.addEventListener('keydown', function (e) {
      try {
        if (e.key !== 'Tab') return;
        var f = [].slice.call(ov.querySelectorAll('input:not([type=hidden]), button, a[href]')).filter(function (x) { return x.offsetWidth || x.offsetHeight; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && D.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
      } catch (err) {}
    });
    ov.addEventListener('click', function (e) { try { if (e.target.closest('[data-szsp-close]')) { e.preventDefault(); closePanel(); } } catch (err) {} });
    ov.querySelector('form').addEventListener('submit', function (e) { if (!(ovInput.value || '').trim()) { e.preventDefault(); ovInput.focus(); } });
  }
  function openPanel() {
    if (!ov || !D.body.contains(ov)) { ov = null; build(); }
    if (!ov.hidden) { ovInput.focus(); return; }
    lastFocus = D.activeElement;
    ov.style.setProperty('--szsp-top', headerBottom() + 'px');
    var t = curTerms();
    if (t && !ovInput.value) ovInput.value = t;
    ov.hidden = false;
    D.documentElement.classList.add('szsp-lock');
    ovInput.focus({ preventScroll: true }); // cùng cú chạm → iPhone bật bàn phím
    ovDrop.update();
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
  }
  function closePanel() {
    if (!ov || ov.hidden) return;
    ov.classList.remove('is-open');
    ov.hidden = true;
    D.documentElement.classList.remove('szsp-lock');
    try { ovInput.blur(); } catch (e) {}
    if (lastFocus && lastFocus.focus && lastFocus !== D.body) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  // ── DESKTOP: dropdown dưới ô search header ──
  var dk = null; // { input, box, drop, wrap }
  function deskBox(input) {
    if (dk && dk.input === input && D.contains(dk.box)) return dk;
    var wrap = input.closest('.search-form-container') || input.closest('form');
    if (!wrap) return null;
    var box = D.createElement('div');
    box.className = 'szsd';
    box.id = 'szsd-drop';
    box.hidden = true;
    box.setAttribute('aria-live', 'polite');
    wrap.classList.add('szsd-anchor');
    wrap.appendChild(box);
    input.setAttribute('aria-controls', 'szsd-drop');
    input.setAttribute('aria-autocomplete', 'list');
    var ph = attr(getCfg(), 'data-ph-desk'); if (ph) input.placeholder = ph;
    dk = { input: input, box: box, drop: new Drop(input, box), wrap: wrap };
    input.addEventListener('input', function () { try { openDesk(); dk.drop.update(); } catch (e) {} });
    input.addEventListener('keydown', function (e) { try { if (e.key === 'Escape') { closeDesk(); return; } arrowNav(e, input, box); } catch (err) {} });
    box.addEventListener('keydown', function (e) { try { if (e.key === 'Escape') { closeDesk(); input.focus(); return; } arrowNav(e, input, box); } catch (err) {} });
    // Tab ra khỏi ô search + dropdown → đóng (click ra ngoài đã có handler capture bên dưới).
    wrap.addEventListener('focusout', function (e) { try { if (!e.relatedTarget || !wrap.contains(e.relatedTarget)) setTimeout(function () { if (!wrap.contains(D.activeElement)) closeDesk(); }, 120); } catch (err) {} });
    return dk;
  }
  function openDesk() {
    if (!dk || !dk.box.hidden) return;
    dk.box.hidden = false;
    dk.wrap.classList.add('is-szsd-open');
    dk.input.setAttribute('aria-expanded', 'true');
  }
  function closeDesk() {
    if (!dk || dk.box.hidden) return;
    dk.box.hidden = true;
    dk.wrap.classList.remove('is-szsd-open');
    dk.input.setAttribute('aria-expanded', 'false');
  }
  function deskInputFrom(t) {
    return t && t.closest && t.closest('form.search-form--header') ? t.closest('form.search-form--header').querySelector('input[name="q"]') : null;
  }

  // Header form: luôn search SP + khớp tiền tố từ cuối (như almagems) — thêm hidden input nếu thiếu.
  function augmentForms() {
  try {
    D.querySelectorAll('form.search-form--header').forEach(function (f) {
      if (f.__szs) return; f.__szs = 1;
      if (!f.querySelector('input[name="type"]')) { var a = D.createElement('input'); a.type = 'hidden'; a.name = 'type'; a.value = 'product'; f.appendChild(a); }
      if (!f.querySelector('input[name="options[prefix]"]')) { var b = D.createElement('input'); b.type = 'hidden'; b.name = 'options[prefix]'; b.value = 'last'; f.appendChild(b); }
      f.addEventListener('submit', function (e) { var i = f.querySelector('input[name="q"]'); if (i && !(i.value || '').trim()) { e.preventDefault(); i.focus(); } });
    });
  } catch (e) {}
  }
  augmentForms();

  D.addEventListener('focusin', function (e) {
    try {
      var t = e.target;
      if (!t.matches || !t.matches('form.search-form--header input[name="q"]')) return;
      var d = deskBox(t); if (!d) return;
      openDesk(); d.drop.update();
    } catch (err) {}
  });

  // Capture: chạy TRƯỚC handler Turbo (window.header → mobileSearch.open) nên panel cũ không mở.
  D.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var icon = t.closest('a.icon-search, .icon-search--mobile');
      if (icon && !icon.closest('form')) {
        var r = icon.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) {
          e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          openPanel(); return;
        }
      }
      // Desktop: nút tròn cam (span.search-submit) = gửi form; ô trống thì focus.
      var sub = t.closest('form.search-form--header .search-submit');
      if (sub) {
        var i = deskInputFrom(sub);
        if (i) { e.preventDefault(); if ((i.value || '').trim()) { var f = i.form; if (f.requestSubmit) f.requestSubmit(); else f.submit(); } else i.focus(); }
        return;
      }
      if (dk && !dk.box.hidden && !dk.wrap.contains(t)) closeDesk();
    } catch (err) {}
  }, true);

  D.addEventListener('keydown', function (e) { if (e.key === 'Escape') { try { closePanel(); } catch (err) {} } });
  try {
    WIDE.addEventListener('change', function () { try { closePanel(); closeDesk(); } catch (e) {} });
  } catch (e) {}
  // Quay lại bằng nút Back (bfcache): đóng panel để trang không kẹt khoá cuộn.
  W.addEventListener('pageshow', function (e) { if (e.persisted) { try { closePanel(); closeDesk(); } catch (err) {} } });
  // Dựng sẵn panel (ẩn, display:none) + danh sách Popular lúc trình duyệt RẢNH trên mobile → cú bấm kính lúp đầu tiên
  // chỉ còn hiện panel (đo CPU 4x: khung hình đầu 139ms → ~70ms). Desktop không dùng panel nên bỏ qua.
  function prebuild() { try { if (!ov && !WIDE.matches && D.body) { build(); ovDrop.update(); } } catch (e) {} }
  W.addEventListener('load', function () {
    if (W.requestIdleCallback) W.requestIdleCallback(prebuild, { timeout: 6000 }); else setTimeout(prebuild, 3000);
  });
  // Sau khi InstantClick thay body: bỏ tham chiếu tới DOM cũ, nhả khoá cuộn, điền lại chip phổ biến.
  function refresh() {
    try {
      if (ov && !D.body.contains(ov)) ov = null;
      if (dk && !D.contains(dk.input)) dk = null;
      D.documentElement.classList.remove('szsp-lock');
      fillPop();
      augmentForms();
      if (W.requestIdleCallback) W.requestIdleCallback(prebuild, { timeout: 6000 }); else setTimeout(prebuild, 3000);
    } catch (e) {}
  }
  window.__szSearch.refresh = refresh;
  D.addEventListener('DOMContentLoaded', function () { try { if (W.InstantClick && W.InstantClick.on) W.InstantClick.on('change', refresh); } catch (e) {} });
  W.szSearch = { open: openPanel, close: closePanel };
})();
